import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CURRENCY } from '../../../../constants/currency';
import Badge from '../../Badge';
import Button from '../../Button';
import PriceDisplay from '../../PriceDisplay';
import { getAsset } from '../../../../util/assets';
import useOpenAlert from '../../../../hooks/useOpenAlert';
import CheckoutItemQuantityInput from '../../../../services/checkout/components/CheckoutCartItem/CheckoutItemQuantityInput';

const propTypes = {
  className: PropTypes.string,
  photoPricing: PropTypes.shape({
    id: PropTypes.string.isRequired,
    digital_downloads_price: PropTypes.shape({
      value: PropTypes.number.isRequired,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }).isRequired,
  }).isRequired,
  cartItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onDigitalDownloadToggle: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

const DigitalDownloadOption = ({
  className,
  photoPricing,
  cartItem,
  onDigitalDownloadToggle,
  onUpdate,
  disabled,
}) => {
  const openAlert = useOpenAlert();
  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-digital-download': true,
  });

  const onAddToCart = quantity => {
    if (disabled) {
      openAlert({
        type: 'info',
        dismissible: false,
        message: ({ onRequestClose }) => (
          <div className="d-flex flex-column align-items-center p-2">
            <img
              src={getAsset('/icon-package-3d.svg')}
              alt=""
              className="mb-2"
            />
            <h4 className="text-center mb-3">
              Hi-Res Download can only be purchased after adding a print package
              to your cart.
            </h4>
            <Button onClick={onRequestClose}>OK</Button>
          </div>
        ),
      });
      return;
    }

    if ((!cartItem && quantity > 0) || (!!cartItem && quantity === 0)) {
      // Either no cart item in cart or removing cart item.
      onDigitalDownloadToggle();
      return;
    }

    // Else, update the quantity.
    onUpdate(cartItem.id, {
      quantity,
    });
  };

  return (
    <div className={classes}>
      <div className="purchasing-option-item-thumb">
        <img
          width={60}
          src={getAsset('/digital-download-illustration.svg')}
          alt=""
        />
      </div>

      <div className="purchasing-option-item-content-wrap">
        <div className="purchasing-option-item-title">
          <div className="text-truncate">Hi&ndash;Res Download</div>
          <div className="purchasing-option-item-info-extra">
            <Badge badgeStyle="yellow" className="text-extra-bold">
              <PriceDisplay
                price={photoPricing.digital_downloads_price.value}
                currency={photoPricing.digital_downloads_price.currency}
              />
            </Badge>
          </div>
        </div>

        <div className="purchasing-option-item-content mb-2">
          <p className="text-sm lh-normal text-dark text-bold">
            Unlock access to hi&ndash;res digital downloads (price per photo).
          </p>
          {disabled && (
            <span className="purchasing-option-item-info-requires-package">
              Requires the purchase of a print package first.
            </span>
          )}
        </div>

        <div className="purchasing-option-item-actions">
          <CheckoutItemQuantityInput
            min={0}
            onChange={value => onAddToCart(value)}
            value={cartItem?.quantity || 0}
            label=""
          />
        </div>
      </div>
    </div>
  );
};

DigitalDownloadOption.propTypes = propTypes;

export default DigitalDownloadOption;
